import { render, staticRenderFns } from "./DemoLayoutSwat.vue?vue&type=template&id=22ab4876&"
import script from "./DemoLayoutSwat.vue?vue&type=script&lang=js&"
export * from "./DemoLayoutSwat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports